import * as CKEditor from 'ckeditor5';

export class AIDButton extends CKEditor.Plugin {
    init() {
        const editor = this.editor;

        // Register the timestamp button and its click handler
        editor.ui.componentFactory.add('aidButton', () => {
            const button = new CKEditor.ButtonView();
            button.set({
                label: 'AI',
                withText: true,
            });
            button.on('execute', () => {
                const selectedElement = editor.model.document.selection.getSelectedElement();

                const callback = editor.config.get('aidButtonClick');
                if (typeof callback === 'function') {
                    callback(selectedElement);
                }
            });
            return button;
        });
    }
}
